import { Card } from "@general-backoffice/core";
import type { DailySignupsData } from "@investhinks/api-client";
import type { Moment } from "moment";
import moment from "moment";
import React, { useMemo } from "react";
import { Badge, Card as RSCard, CardBody } from "reactstrap";

import DailySignUpsGraph from "./graphs/DailySignUpsGraph";

const STARTING_YEAR = 2023;
const FINAL_YEAR = parseInt(moment().format("YYYY"), 10);
const years: number[] = [];
for (let y = STARTING_YEAR; y <= FINAL_YEAR; y++) {
  years.push(y);
}

type DayStats = DailySignupsData["perDay"][string];

interface DailySignUpsGraphCardProps {
  data?: Record<string, DayStats>;
  date: Moment;
  isLoading: boolean;
}

const DailySignUpsGraphCard: React.FC<DailySignUpsGraphCardProps> = ({ data = {}, date, isLoading }) => {
  const { notVerified, nonClients, clients } = useMemo(
    () =>
      Object.values(data).reduce(
        (r, { notVerified = 0, nonClients = 0, clients = 0 }) => {
          r.notVerified += notVerified;
          r.nonClients += nonClients;
          r.clients += clients;
          return r;
        },
        { notVerified: 0, nonClients: 0, clients: 0 }
      ),
    [data]
  );

  return (
    <RSCard>
      <Card.Header title={`${date.format("MMMM YYYY")} Sign Ups`} />
      <CardBody className="pb-4">
        <div className="position-relative w-100 mb-4">
          <div className="position-absolute d-flex top-0 left-0 w-100" style={{ transform: "translateY(-50%)" }}>
            <Badge color="gray" children={`Not verified: ${notVerified}`} />
            <Badge color="primary" children={`Non clients: ${nonClients}`} />
            <Badge color="default" children={`Clients: ${clients}`} />
          </div>
        </div>

        <DailySignUpsGraph
          data={data}
          isLoading={isLoading}
          date={date}
          className="rounded-bottom overflow-hidden"
          style={{ height: "calc(100vh - 400px)", minHeight: 400 }}
        />
      </CardBody>
    </RSCard>
  );
};

export default DailySignUpsGraphCard;
